import store from "@/store"

export default function superuser({ next, router }) {
    if(!store || !store.state.auth.isLogged || !store.state.auth.superadmin) {
        router.push('/admin/login')
        return
    }
    return next()
}
